import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        '& > *': {
            margin: theme.spacing(2)
        },
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        width: '100vw',
        overflow: 'auto',
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2),
        padding: 0,
    },
    errMsg: {
        color: 'red',
        marginTop: theme.spacing(2),
    },
    successMsg: {
        color: 'green',
        marginTop: theme.spacing(2),
    },
    button: {
        marginLeft: theme.spacing(2),
    },
    fileUpload: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#e3e8ea',
        height: '30vh',
        border: '2px dashed gray',
        cursor: 'pointer'
    },
    fileUploadText: {
        fontSize: '1.5rem'
    },
    selectList: {
        margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
        width: '100%',
    },
});
